import React from 'react';
import PropTypes from 'prop-types';

import { withSubscription } from '@spotahome/soyuz-mediator';
import { FavoriteClaim as FavoriteClaimComponent } from '@spotahome/ui-library';

import '@spotahome/ui-library/lib/components/FavoriteClaim.css';
import '@spotahome/ui-library/lib/components/Button.css';
import '@spotahome/ui-library/lib/components/CloseButton.css';

import { OPEN_FAVORITE_CLAIM } from '../channels';

import './login/LoginModalStyles';

import withModalProps from './login/withModalProps';
import withModalHandle from './withModalHandle';

const FavoriteClaim = withSubscription({ channelName: OPEN_FAVORITE_CLAIM })(
  props => (
    <FavoriteClaimComponent
      modalProps={props.modalProps}
      isOpen={props.isOpen}
      onClose={props.onClose}
    />
  )
);

const FavoriteClaimModal = withModalHandle()(
  withModalProps()(props => (
    <FavoriteClaim
      modalProps={
        props.modalProps
      }
      isOpen={props.isModalOpen}
      onClose={props.handleModalClose}
      onEvent={props.handleModalOpen}
    />
  ))
);

FavoriteClaim.propTypes = {
  modalProps: PropTypes.shape().isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default FavoriteClaimModal;
